module.exports = __webpack_public_path__ + "img/5.1b8a3721.jpg";